import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ShopifyAuth() {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        const shop = urlParams.get('shop');
        const host = urlParams.get('host');

        if (!code || !shop) {
          throw new Error('Missing required parameters');
        }

        // Exchange code for access token
        const response = await fetch(`/api/shopify/auth/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code, shop, host })
        });

        const data = await response.json();

        if (data.success) {
          setStatus('success');
          // Store Shopify session data
          localStorage.setItem('shopify_session', JSON.stringify(data.session));

          // Redirect to Shopify app
          const redirectUrl = `/shopify?shop=${shop}&host=${host}`;
          setTimeout(() => navigate(redirectUrl), 1000);
        } else {
          throw new Error(data.message || 'Authentication failed');
        }
      } catch (err) {
        setError(err.message);
        setStatus('error');
      }
    };

    handleAuthCallback();
  }, [location, navigate]);

  if (status === 'processing') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'system-ui'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '18px', marginBottom: '10px' }}>
            🔗 Connecting to RADAR...
          </div>
          <div style={{ color: '#666' }}>
            Setting up your competitive intelligence dashboard
          </div>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'system-ui'
      }}>
        <div style={{ textAlign: 'center', color: '#e74c3c' }}>
          <div style={{ fontSize: '18px', marginBottom: '10px' }}>
            ❌ Authentication Failed
          </div>
          <div>{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'system-ui'
    }}>
      <div style={{ textAlign: 'center', color: '#27ae60' }}>
        <div style={{ fontSize: '18px', marginBottom: '10px' }}>
          ✅ Successfully Connected!
        </div>
        <div style={{ color: '#666' }}>
          Redirecting to your RADAR dashboard...
        </div>
      </div>
    </div>
  );
}